import { canAccess } from '@/acl/roles';

const getMenuItemsList = (currentLocale = 'en') => [
  {
    url: '/',
    name: 'BrokingTools',
    slug: 'dashboard',
    location: 'internal',
    tagColor: 'warning',
    iconType: 'fal',
    icon: 'file-alt',
    class: '',
  },
  {
    url: '/coverholder-suite',
    name: 'CoverholderSuite',
    slug: 'coverholder_suite',
    location: 'internal',
    tagColor: 'warning',
    iconType: 'fal',
    icon: 'file-alt',
    class: '',
  },
  {
    url: '/notify-a-claim',
    name: 'ClaimNotificationForms',
    slug: 'notify_a_claim',
    location: 'internal',
    tagColor: 'warning',
    iconType: 'fas',
    icon: 'exclamation-triangle',
    class: '',
  },
  {
    url: '/work-in-progress',
    name: 'WorkInProgress',
    slug: 'work_in_progress',
    location: 'internal',
    tagColor: 'warning',
    iconType: 'fal',
    icon: 'tasks',
    class: '',
  },
  {
    url: 'https://homepage.fides.international/contact-list/?company=ipr',
    name: 'Contacts',
    slug: 'external',
    location: 'external',
    i18n: 'Contacts',
    tagColor: 'warning',
    iconType: 'fal',
    icon: 'users',
    class: '',
    target: '_blank'
  },
  {
    url: process.env.VUE_APP_REQUEST_REFERAL_URL,
    name: 'RequestReferral',
    slug: 'request_referral',
    location: 'external',
    i18n: 'RequestReferral',
    tagColor: 'warning',
    iconType: 'fas',
    icon: 'arrow-alt-up',
    class: 'RequestReferral',
    target: '_blank'
  },
  {
    url: process.env.VUE_APP_REQUEST_QUOTARION_URL,
    name: 'RequestQuotation',
    slug: 'upload_quotation',
    location: 'external',
    i18n: 'RequestQuotation',
    tagColor: 'warning',
    iconType: 'fas',
    icon: 'arrow-alt-up',
    class: 'RequestQuotation',
    target: '_blank'
  },
  {
    url: `${process.env.VUE_APP_LANDING_PAGE_URL}?lang=${currentLocale || 'en'}`,
    name: 'ReturnToFIDES',
    slug: 'external',
    location: 'external',
    i18n: 'ReturnToFIDES',
    tagColor: 'warning',
    iconType: 'fas',
    icon: 'arrow-alt-left',
    class: 'return-to-fides mb-4',
    target: '_blank'
  },
];

const canAccessMenuItem = async (item) => {
  return await canAccess(item);
}

export const getMenuItems = async (currentLocale = 'en') => {
  const menuItems = getMenuItemsList(currentLocale);
  const filteredMenuItems = [];

  for (const menuItem of menuItems) {
    if (menuItem.name === 'ReturnToFIDES'
      || await canAccessMenuItem(menuItem)
    ) {
      filteredMenuItems.push(menuItem);
    }
  }

  return filteredMenuItems;
};
